import styles from './ProductCard.module.css';

interface ProductPriceProps {
    price: number;
    discount?: number | null;
    discountedPrice?: number | null;
}

export default function ProductPrice({
    price,
    discount,
    discountedPrice,
}: ProductPriceProps) {
    const formatPrice = (value: number) => {
        return new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: 'RUB',
            minimumFractionDigits: 0,
        }).format(value);
    };

    const hasDiscount = !!(discount && discountedPrice);
    const finalPrice = hasDiscount ? discountedPrice! : price;

    return (
        <div className={styles.productCardPriceWrapper}>
            {hasDiscount ? (
                <div className={styles.productCardPriceRow}>
                    <span className={styles.productCardPriceNew}>{formatPrice(finalPrice)}</span>
                    <span className={styles.productCardPriceOld}>{formatPrice(price)}</span>
                </div>
            ) : (
                <span className={styles.productCardPrice}>{formatPrice(finalPrice)}</span>
            )}
        </div>
    );
}
